import dayjs from "dayjs";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import Colors from "../../constant/Colors";
import { useHistory } from "react-router-dom";
import { convertCurrency } from "../../store/actions/dollarPricesAction";
import useSWR from "swr";

import { Error, fetcher, Loading } from "../../components/UI/TableView/ShowPaginationData";
import { calculateCaffetteriaTotalPrice } from "../../customFunction/PricesCalculation/caffetteria";
import { calculateCoursesTotalPrice } from "../../customFunction/PricesCalculation/courses";
import { calculateSupplementsTotalPrice } from "../../customFunction/PricesCalculation/supplements";
import { calculateExpensesTotalPrice } from "../../customFunction/PricesCalculation/expenses";
import { calculateMembershipTotalPrice } from "../../customFunction/PricesCalculation/memberships";
import { showInIQD } from "../../customFunction/Numeral/CurrencyFormat";
import { useSelector } from "react-redux";

function DailyReportScreen() {
  const currentCenterId = JSON.parse(localStorage.getItem('centerId')).centerId
  const [currentCurrency] = useState('IQD')
  const { data: cafeOrders, isLoading: OLoading, error: OError } = useSWR('/orders?fromReception=true&centerId=' + currentCenterId + "&startDate=" + dayjs().format('YYYY-MM-DD'), fetcher)
  const { data: courses, isLoading: CLoading, error: CError } = useSWR('/courses?centerId=' + currentCenterId + "&startDate=" + dayjs().format('YYYY-MM-DD'), fetcher)
  const { data: expenses, isLoading: ELoading, error: EError } = useSWR('/expenses?centerId=' + currentCenterId + "&startDate=" + dayjs().format('YYYY-MM-DD'), fetcher)
  const { data: swimmingSales, isLoading: SLoading, error: SError } = useSWR('/swimming-sales?centerId=' + currentCenterId + "&startDate=" + dayjs().format('YYYY-MM-DD'), fetcher)
  const { data: memberships, isLoading: MLoading, error: MError } = useSWR('/memberships?centerId=' + currentCenterId + "&startDate=" + dayjs().format('YYYY-MM-DD'), fetcher)
  const { data: nutritionSales, isLoading: NLoading, error: NError } = useSWR('/nutrition-sales?centerId=' + currentCenterId + "&startDate=" + dayjs().format('YYYY-MM-DD'), fetcher)
  let User = useSelector((state) => state.authentication.user);

  const [displayedData, setDisplayedData] = useState(false);
  const [membershipsData, setMembershipsData] = useState(false);
  const [summaryData, setSummaryData] = useState(false);

  const createData = async () => {
    try {
      let expensesTotalPrice = await calculateExpensesTotalPrice(expenses, currentCurrency);
      let caffetteriaTotalPrice = await calculateCaffetteriaTotalPrice(
        cafeOrders,
        currentCurrency,
        0
      ).cafeteria;
      let otherRevenueTotalPrice = await calculateCaffetteriaTotalPrice(
        cafeOrders,
        currentCurrency,
        0
      ).otherRevenue;
      let courseTotalPrice = await calculateCoursesTotalPrice(courses, currentCurrency);
      let swimmingSalesTotalPrice = await calculateSupplementsTotalPrice(
        swimmingSales,
        currentCurrency
      );
      let nutritionSalesTotalPrice = await calculateSupplementsTotalPrice(
        nutritionSales,
        currentCurrency
      );

      let membershipsDetails = await calculateMembershipTotalPrice(
        memberships,
        currentCurrency
      );

      let totalRevenue =
        caffetteriaTotalPrice +
        courseTotalPrice +
        swimmingSalesTotalPrice +
        nutritionSalesTotalPrice +
        otherRevenueTotalPrice +
        membershipsDetails.finalPrice;
      let totalExpenses = expensesTotalPrice;
      let totalProfit = totalRevenue - totalExpenses;

      setDisplayedData({
        expensesTotalPrice,
        caffetteriaTotalPrice,
        courseTotalPrice,
        swimmingSalesTotalPrice,
        otherRevenueTotalPrice,
        nutritionSalesTotalPrice
      });

      setMembershipsData(membershipsDetails);
      setSummaryData({ totalExpenses, totalProfit, totalRevenue });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (courses && cafeOrders && expenses && memberships && swimmingSales && nutritionSales) createData();
  }, [courses, currentCurrency, cafeOrders, expenses, memberships && nutritionSales && swimmingSales]);

  if (OLoading || CLoading || ELoading || MLoading || SLoading || NLoading) {
    return <div className="flex items-center justify-center w-full h-full bg-white" ><Loading /></div>
  }

  if (OError || CError || EError || MError || SError || NError) {
    return <div className="flex items-center justify-center w-full h-full bg-white" ><Error /></div>
  }
  // console.log({ supplements })
  return (
    <div className='flex justify-center w-full h-fit '>
      <div className='w-[90%] flex flex-col justify-center items-center my-5 '>
        {displayedData && <SummaryReport user={User} currentCurrency={currentCurrency} swimmingSales={swimmingSales} nutritionSales={nutritionSales} cafeOrders={cafeOrders} courses={courses} expenses={expenses} memberships={memberships} />}
        {membershipsData && (User?.type === 0 || User?.type === 2) && <MembershipContainer currentCurrency={currentCurrency} newUser={membershipsData.newUser} oldUser={membershipsData.oldUser} type={0} memberships={memberships} />}
        {displayedData && <OtherReport user={User} type={0} currentCurrency={currentCurrency} cafeOrders={cafeOrders} courses={courses} nutritionSales={nutritionSales} expenses={expenses} swimmingSales={swimmingSales} displayedData={displayedData} />}
      </div>
    </div>
  );
}
const SummaryReport = ({ memberships, user, courses, cafeOrders, expenses, swimmingSales, nutritionSales }) => {
  // we have two different types of total available money one for reception one for cafeteria
  const history = useHistory();
  const [{ totalAvailable, totalMoneyReceived }, setPrices] = useState({
    totalMoneyReceived: { dollar: 0, iqd: 0 }, totalAvailable: { dollar: 0, iqd: 0 }
  })

  const setup = async () => {
    if (user.type === 0) {
      const data = { memberships, courses, cafeOrders, swimmingSales, nutritionSales }
      const dt = { totalMoneyReceived: { dollar: 0, iqd: 0 }, totalAvailable: { dollar: 0, iqd: 0 } }
      //! calculate revenue
      Object.keys(data).map((key) => {
        const { totalMoneyReceived, totalAvailable } = calculateMemberships(data[key], key === 'memberships' ? 0 : 1)
        dt.totalMoneyReceived.dollar += totalMoneyReceived.dollar
        dt.totalMoneyReceived.iqd += totalMoneyReceived.iqd
        dt.totalAvailable.dollar += totalAvailable.dollar
        dt.totalAvailable.iqd += totalAvailable.iqd
      })
      //! calculate expenses
      const { totalAvailable: totalAvailableExpenses } = calculateMemberships(expenses, 1)
      dt.totalAvailable.dollar -= totalAvailableExpenses.dollar
      dt.totalAvailable.iqd -= totalAvailableExpenses.iqd
      setPrices(dt)
    } else if (user.type === 2) {
      // calc for reception report user.type === 2
      const cafe = cafeOrders.filter((order) => order.type === 1 || order.type === 6)
      const data = { memberships, courses, cafeOrders: cafe }
      const dt = { totalMoneyReceived: { dollar: 0, iqd: 0 }, totalAvailable: { dollar: 0, iqd: 0 } }

      Object.keys(data).map((key) => {
        const { totalMoneyReceived, totalAvailable } = calculateMemberships(data[key], key === 'memberships' ? 0 : 1)
        dt.totalMoneyReceived.dollar += totalMoneyReceived.dollar
        dt.totalMoneyReceived.iqd += totalMoneyReceived.iqd
        dt.totalAvailable.dollar += totalAvailable.dollar
        dt.totalAvailable.iqd += totalAvailable.iqd
      })
      //! calculate expenses
      const { totalAvailable: totalAvailableExpenses } = calculateMemberships(expenses, 1)
      dt.totalAvailable.dollar -= totalAvailableExpenses.dollar
      dt.totalAvailable.iqd -= totalAvailableExpenses.iqd
      setPrices(dt)
    } else if (user.type === 4) {
      const cafe = cafeOrders.filter((order) => order.type === 0)
      const data = { swimmingSales, nutritionSales, cafeOrders: cafe }

      const dt = { totalMoneyReceived: { dollar: 0, iqd: 0 }, totalAvailable: { dollar: 0, iqd: 0 } }

      Object.keys(data).map((key) => {
        const { totalMoneyReceived, totalAvailable } = calculateMemberships(data[key], key === 'memberships' ? 0 : 1)
        dt.totalMoneyReceived.dollar += totalMoneyReceived.dollar
        dt.totalMoneyReceived.iqd += totalMoneyReceived.iqd
        dt.totalAvailable.dollar += totalAvailable.dollar
        dt.totalAvailable.iqd += totalAvailable.iqd
      })
      //! calculate expenses
      // const { totalAvailable: totalAvailableExpenses } = calculateMemberships(expenses, 1)
      // dt.totalAvailable.dollar -= totalAvailableExpenses.dollar
      // dt.totalAvailable.iqd -= totalAvailableExpenses.iqd
      setPrices(dt)
    }
  }

  useEffect(() => {
    setup()
  }, [memberships, courses, cafeOrders, expenses])

  const onClickMemberships = () => {
    history.push(`${window.location.pathname}/memberships`);
  };

  return (
    <div className='w-5/6 border'>
      <div className='cursor-pointer' onClick={onClickMemberships}>
        <HeaderLabel label={t("reportSummaryNew")} />
      </div>

      <div className='flex w-full p-4 mt-5 justify-evenly'>

        <Index
          label={t("totalAvailableMoney")}
          color={Colors.mainAqwaBlue}
          value={showInIQD(totalAvailable.dollar, 'USD') + ' - (' + (showInIQD(totalAvailable.iqd)) + ')'}
          onClick={onClickMemberships}
        />
      </div>
    </div>
  );
};

const calculateMemberships = (memberships, type) => {
  let totalMoneyReceived = { dollar: 0, iqd: 0 }
  let totalChange = { iqd: 0, dollar: 0 }
  let totalAvailable = { iqd: 0, dollar: 0 }

  memberships.map((membership) => {
    const { paymentDetails } = type === 0 ? membership.package : membership
    const { payedType } = paymentDetails
    const checkCurrency = payedType === 0 ? 'dollar' : payedType === 1 ? 'iqd' : 'both'
    if (checkCurrency === 'both') {
      totalMoneyReceived.dollar += paymentDetails.dollarAmount
      totalMoneyReceived.iqd += paymentDetails.iqdAmount
    } else {
      totalMoneyReceived[checkCurrency] += paymentDetails.amountByCustomer
    }
    if (paymentDetails.changeType === 1) {
      totalChange.iqd += paymentDetails.changePrice
    } else if (paymentDetails.changeType === 0) {
      totalChange.dollar += paymentDetails.changePrice
    } else {
      //!both
      totalChange.iqd += paymentDetails.iqdChange
      totalChange.dollar += paymentDetails.dollarChange
    }
    if (payedType === 0) {
      totalAvailable.dollar += (paymentDetails.amountByCustomer)
    } else if (payedType === 1) {
      totalAvailable.iqd += (paymentDetails.amountByCustomer)
    } else if (payedType === 2) {
      totalAvailable.dollar += (paymentDetails.dollarAmount)
      totalAvailable.iqd += (paymentDetails.iqdAmount)
    }
  })
  totalAvailable.iqd -= totalChange.iqd
  totalAvailable.dollar -= totalChange.dollar

  return { totalMoneyReceived, totalChange, totalAvailable }
}
const MembershipContainer = ({ memberships, currentCurrency, newUser, oldUser, type }) => {
  const history = useHistory();
  const { totalAvailable, totalMoneyReceived } = type === 0 ? calculateMemberships(memberships, 0) : {}
  const onClickMemberships = () => {
    history.push(`${window.location.pathname}/memberships`);
  };

  return (
    <div className='w-5/6 border'>
      <div className='cursor-pointer' onClick={onClickMemberships}>
        <HeaderLabel label={t("membershipSummary")} />
      </div>

      <div className='flex w-full p-4 mt-5 justify-evenly'>
        {type === 0 ? <>
          <Index
            label={t("membershipBenefit")}
            color={Colors.mainAqwaBlue}
            value={showInIQD(totalAvailable.dollar, 'USD') + ' - ' + showInIQD(totalAvailable.iqd)}
            onClick={onClickMemberships}
          />
        </> : <>
          <Index
            label={t("membershipBenefit")}
            color={Colors.mainAqwaBlue}
            value={convertCurrency(memberships.finalPrice, currentCurrency, true, null, true)}
            onClick={onClickMemberships}
          />
        </>}
        <Index
          label={t("newUser")}
          color={Colors.mainAqwaBlue}
          value={newUser}
        />
        <Index
          label={t("renew")}
          color={Colors.mainAqwaBlue}
          value={oldUser}
        />
      </div>
    </div>
  );
};

const OtherReport = ({ displayedData, type, user, currentCurrency, cafeOrders, courses, expenses, swimmingSales, nutritionSales }) => {
  const history = useHistory();
  const { totalAvailable: totalAvailableExpenses, totalMoneyReceived: totalMoneyReceivedExpenses } = type === 0 ? calculateMemberships(expenses, 1) : {}
  const cafeData = type === 0 ? calculateCaffetteriaTotalPrice(cafeOrders, currentCurrency, 1) : {}
  const { totalAvailable: totalAvailableCourses, totalMoneyReceived: totalMoneyReceivedCourses } = type === 0 ? calculateMemberships(courses, 1) : {}
  const { totalAvailable: totalAvailableSwimmingSales, totalMoneyReceived: totalMoneyReceivedSupplements } = type === 0 ? calculateMemberships(swimmingSales, 1) : {}
  const { totalAvailable: totalAvailableNutritionSales, totalMoneyReceived: totalMoneyReceivedNutrition } = type === 0 ? calculateMemberships(nutritionSales, 1) : {}

  return (
    <div className='w-5/6 border'>
      <HeaderLabel label={t("financeSummary")} />
      <div className='flex flex-wrap w-full gap-6 p-4 mt-5 justify-evenly'>
        {type === 0 ? <>
          {(user.type === 0 || user.type === 2) && <Index
            label={t("expenses")}
            color={Colors.soldColor}
            value={showInIQD(totalAvailableExpenses.dollar, 'USD') + ' - ' + showInIQD(totalMoneyReceivedExpenses.iqd)}
            onClick={() => history.push(`/expenses`)}
          />}
          {(user.type === 0 || user.type === 2) && <Index
            label={t("balance") + ' + ' + t("cafeteriaCard")}
            color={Colors.mainAqwaBlue}
            value={showInIQD(cafeData.balance.totalAvailable.dollar + cafeData.card.totalAvailable.dollar, 'USD') + ' - ' + showInIQD(cafeData.balance.totalAvailable.iqd + cafeData.card.totalAvailable.iqd)}
            onClick={() => history.push(user.type === 2 ? "/cafeteria-card?type=1" : (`/others/other-revenue?type=0`))}
          />}
          {(user.type === 0 || user.type === 4) && <Index
            label={t("cafeteriaCash")}
            color={Colors.mainAqwaBlue}
            value={showInIQD(cafeData.cash.totalAvailable.dollar, 'USD') + ' - ' + showInIQD(cafeData.cash.totalAvailable.iqd)}
            onClick={() => history.push(`/others/other-revenue?type=0`)}
          />}
          {(user.type === 0 || user.type === 2) && <Index
            label={t("requestCourse")}
            color={Colors.mainAqwaBlue}
            value={showInIQD(totalAvailableCourses.dollar, 'USD') + ' - ' + showInIQD(totalAvailableCourses.iqd)}
            onClick={() => history.push(`/courses`)}
          />}
          {(user.type === 0 || user.type === 4) && <>
            <Index
              label={t("swimmingSales")}
              color={Colors.mainAqwaBlue}
              value={showInIQD(totalAvailableSwimmingSales.dollar, 'USD') + ' - ' + showInIQD(totalAvailableSwimmingSales.iqd)}
              onClick={() => history.push(`/others/swimming-items`)}
            />
            <Index
              label={t("nutritionSales")}
              color={Colors.mainAqwaBlue}
              value={showInIQD(totalAvailableNutritionSales.dollar, 'USD') + ' - ' + showInIQD(totalAvailableNutritionSales.iqd)}
              onClick={() => history.push(`/others/nutrition-sales`)}
            />
          </>}
          {/* <Index
            label={t("physicalTherapy")}
            color={Colors.mainAqwaBlue}
            value={showInIQD(cafeData.physicalTherapy.totalAvailable.dollar, 'USD') + ' - ' + showInIQD(cafeData.physicalTherapy.totalAvailable.iqd)}
            onClick={() => history.push(`/others/other-revenue?type=7`)}
          /> */}
        </> : <>
          <Index
            label={t("expenses")}
            color={Colors.mainAqwaBlue}
            value={convertCurrency(displayedData.expensesTotalPrice, currentCurrency, true)}
            onClick={() => history.push(`/expenses`)}
          />
          <Index
            label={t("cafeteria")}
            color={Colors.mainAqwaBlue}
            value={convertCurrency(displayedData.caffetteriaTotalPrice, currentCurrency, true)}
            onClick={() => history.push(`/others/other-revenue`)}
          />
          <Index
            label={t("requestCourse")}
            color={Colors.mainAqwaBlue}
            value={convertCurrency(displayedData.courseTotalPrice, currentCurrency, true)}
            onClick={() => history.push(`/courses`)}
          />
          {/* <Index
            label={t("swimmingSales")}
            color={Colors.mainAqwaBlue}
            value={convertCurrency(displayedData.swimmingSales, currentCurrency, true, null, true)}
            onClick={() => history.push(`/supplements`)}
          /> */}
          <Index
            label={t("otherRevenue")}
            color={Colors.mainAqwaBlue}
            value={convertCurrency(displayedData.otherRevenueTotalPrice, currentCurrency, true, null, true)}
            onClick={() => history.push(`/others/other-revenue`)}
          /></>}

      </div>
    </div>
  );
};

const Index = ({ label, color, value, description, onClick }) => {
  return (
    <div className='pb-3 pl-3 border-l cursor-pointer' onClick={onClick}>
      <h1 className='font-medium opacity-90' style={{ color }}>
        {label}
      </h1>
      <h1 className='text-3xl font-light'>{value}</h1>
      <h1 className='text-sm font-medium opacity-50'>{description}</h1>
    </div>
  );
};

const HeaderLabel = ({ label }) => {
  return (
    <div>
      <h1 className='p-4 font-bold opacity-70'>{label}</h1>
    </div>
  );
};

export default DailyReportScreen;
